import React, { useMemo } from "react";
import { RankingMetricasQualidadeViewProps } from "../types";
import { NavigationButtons } from "../../Producao/components/NavigationButtons";
import { LojaSelector } from "../../Producao/components/LojaSelector";
import { Header } from "./Header";
import { RankingInspecaoSnapshotsTvTable } from "./RankingInspecaoSnapshotsTvTable";

export const RankingMetricasQualidadeView: React.FC<
  RankingMetricasQualidadeViewProps
> = ({
  snapshots,
  snapshotsPreviousPeriod,
  isLoadingSnapshots,
  isLoadingSnapshotsPreviousPeriod,
  lojas = [],
  selectedLojaId,
  showLojaSelector = false,
  selectedDateISO,
  onSelectedDateChange,
  selectedPeriod,
  onSelectedPeriodChange,
  selectedPeriodLabel,
  comparisonPeriodLabel,
  dateLabel,
  comparisonDateLabel,
  selectedDateDayMonth,
  comparisonDateDayMonth,
  selectedLojaNome,
  onGoHome,
  onToggleLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  const lojaNomeResumo = useMemo(() => {
    if (selectedLojaId === undefined) return "Todas";
    return selectedLojaNome ?? `Loja #${selectedLojaId}`;
  }, [selectedLojaId, selectedLojaNome]);

  return (
    <div className="relative flex h-dvh max-h-dvh flex-col overflow-hidden bg-red-900 text-white">
      <NavigationButtons
        lojasCount={lojas.length}
        onGoHome={onGoHome}
        onToggleLojaSelector={onToggleLojaSelector}
        selectedDateISO={selectedDateISO}
        onSelectedDateChange={onSelectedDateChange}
      />

      <LojaSelector
        lojas={lojas}
        selectedLojaId={selectedLojaId}
        showLojaSelector={showLojaSelector}
        onSelectAllLojas={onSelectAllLojas}
        onSelectLoja={onSelectLoja}
      />

      <Header
        selectedPeriod={selectedPeriod}
        selectedPeriodLabel={selectedPeriodLabel}
        comparisonPeriodLabel={comparisonPeriodLabel}
        dateLabel={dateLabel}
        comparisonDateLabel={comparisonDateLabel}
        selectedLojaId={selectedLojaId}
        selectedLojaNome={selectedLojaNome}
      />

      <div className="fixed right-2 top-2 z-40 sm:right-4 sm:top-4">
        <div className="inline-flex rounded-full border border-white/10 bg-black/20 p-0.5 opacity-65 backdrop-blur-sm transition-opacity focus-within:opacity-100 hover:opacity-100">
          {(
            [
              ["dia", "Dia"],
              ["semana", "Semana"],
              ["mes", "Mês"],
            ] as const
          ).map(([periodId, periodLabel]) => (
            <button
              key={periodId}
              type="button"
              onClick={() => onSelectedPeriodChange(periodId)}
              className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide transition-colors sm:px-3 sm:text-xs ${
                selectedPeriod === periodId
                  ? "bg-yellow-300 text-red-900"
                  : "text-white/70 hover:bg-white/10 hover:text-white"
              }`}
            >
              {periodLabel}
            </button>
          ))}
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-2 pb-1 pt-0 sm:px-3 sm:pb-1.5 lg:px-12">
        <RankingInspecaoSnapshotsTvTable
          snapshots={snapshots}
          snapshotsPreviousPeriod={snapshotsPreviousPeriod}
          isLoading={isLoadingSnapshots}
          isLoadingPreviousPeriod={isLoadingSnapshotsPreviousPeriod}
          lojaNomeResumo={lojaNomeResumo}
          showLojaColumn={selectedLojaId === undefined}
          comparisonPeriodLabel={comparisonPeriodLabel}
          comparisonDateLabel={comparisonDateLabel}
          selectedDateDayMonth={selectedDateDayMonth}
          comparisonDateDayMonth={comparisonDateDayMonth}
        />
      </div>
    </div>
  );
};
